import { makeStyles } from '@mui/styles';
import Colors from 'constants/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#E2F0FF',
    height: '100vh',
  },
  backgroundContainer: {
    height: '100%',
  },
  title: {
    // width: '400px',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '40px !important',
    marginTop: theme.spacing(2),
    color: Colors.primary,
  },
  description: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    margin: theme.spacing(2, 0, 5, 0),
    width: 400,
  },
  label: {
    color: '#2A3341 !important',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '16px !important',
    margin: theme.spacing(4, 0, 1, 0),
  },
  paper: {
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  field: {
    background: '#ECF2F7',
    height: 40,
    '& .MuiOutlinedInput-input': {
      padding: '8px 10px',
    },
  },
  submit: {
    color: 'white',
    margin: `${theme.spacing(3, 0, 2)} !important`,
    background: Colors.primary,
    borderRadius: '8px',
    height: '44px',
    '& .MuiButton-label': {
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '18px',
    },
    '&:hover': {
      background: '#0077B6',
    },
  },
  disabled: {
    backgroundColor: '#0077B6 !important',
  },
  link: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    textAlign: 'left',
  },
  hyperlink: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    textAlign: 'center',
    color: Colors.primary,
    textDecoration: 'none',
    cursor: 'pointer',
  },
  logo: {
    margin: theme.spacing(4),
    width: 230,
    height: 54,
  },
  containerLogin: {
    // height: '100%',
    // border: '1px solid #E5E7EB',
    // boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    height: 'fit-content',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    padding: '10vh',
    position: 'relative',
    right: '-50px',
    overflow: 'visible',
  },
  backButton: {
    margin: theme.spacing(3),
    '& .MuiButton-label': {
      textTransform: 'none',
      color: '#8692A6',
      fontWeight: 600,
      fontSize: '16px',
    },
  },
  formCheckbox: {
    marginTop: 10,
  },
}));

export default useStyles;
